module.exports = __webpack_public_path__ + "img/ostalo.48e4284a.svg";